<footer class="footer">
    <div class="container-l">
      <div class="w-layout-grid grid _4er-footer">
        <div id="w-node-_6ad1fc08-75d2-e2f1-a56c-11e91f066df3-1f066db3" class="grid-item">
          <div class="footer-contact-wrapper">
            <div class="footer-headline text-default b-10px">Phone</div>
            <a data-w-id="81e50653-1201-da07-358b-ef3b78c1d32b" href="tel:+97145693115" class="footer-link-contact b-25px w-inline-block">
              <div>+971 4 380 5710</div>
              <div class="footer-link-contact-line">
                <div class="footer-link-contact-line-inner"></div>
              </div>
            </a>
            <div class="footer-headline text-default b-10px">EMAIL</div>
            <a data-w-id="0ad79aeb-861a-114d-4395-cccf416d446e" href="mailto:info@hudsondubai.com?subject=Hello%20Hudson" class="footer-link-contact w-inline-block">
              <div>info&#64;hudsondubai.com</div>
              <div class="footer-link-contact-line">
                <div class="footer-link-contact-line-inner"></div>
              </div>
            </a>
          </div>
        </div>
        <div id="w-node-_6ad1fc08-75d2-e2f1-a56c-11e91f066dc9-1f066db3" class="grid-item">
          <div class="footer-line"></div>
        </div>
        <div class="grid-item">
          <div class="footer-content-wrapper">
            <div data-hover="false" data-delay="0" class="dropdown r-50px w-dropdown">
              <div class="dropdown-footer w-dropdown-toggle">
                <div class="dropdown-icon-footer w-icon-dropdown-toggle"></div>
                <div class="footer-headline text-default">Company</div>
              </div>
              <nav class="dropdown-list-footer w-dropdown-list">
                <a [routerLink]="['/services']" class="link-footer">Services</a>
                <a [routerLink]="['/about']" class="link-footer">About</a>
                <!-- <a href="career.html" class="link-footer">Career</a> -->
                <a [routerLink]="['/why']" class="link-footer">Why Dubai?</a>
                <a [routerLink]="['/developers']" class="link-footer">Developer</a>
                <a [routerLink]="['/guides']" class="link-footer">Guide</a>
                <a [routerLink]="['/contact']" class="link-footer">Contact</a>
              </nav>
            </div>
            <div data-hover="false" data-delay="0" class="dropdown w-dropdown">
              <div class="dropdown-footer w-dropdown-toggle">
                <div class="dropdown-icon-footer w-icon-dropdown-toggle"></div>
                <div class="footer-headline text-default">Social</div>
              </div>
              <nav class="dropdown-list-footer w-dropdown-list">
                <a href="https://www.instagram.com/hudsondubai/" target="_blank" class="link-footer">Instagram</a>
                <a href="https://facebook.com/Hudsondubai/" target="_blank" class="link-footer">Facebook<br></a>
                <a href="https://www.linkedin.com/company/hudsondubai/" target="_blank" class="link-footer">LinkedIn</a>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="w-layout-grid grid _3er-footer">
        <div id="w-node-_6ad1fc08-75d2-e2f1-a56c-11e91f066e00-1f066db3" class="grid-item">
          <div class="text-xsmall">©2025 Hudson Real Estate LLC.</div>
        </div>
        <div id="w-node-_6ad1fc08-75d2-e2f1-a56c-11e91f066dfb-1f066db3" class="grid-item">
          <div class="footer-brand-wrapper">
            <a [routerLink]="['']" aria-current="page" class="footer-brand w-nav-brand w--current"><img src="../../assets/images/hudson-icon.svg" loading="lazy" width="150" alt="" class="brand-image-footer"></a>
          </div>
        </div>
        <div id="w-node-_984fe8c5-bc81-f672-e5ca-b2686e49dea8-1f066db3" class="grid-item">
          <div class="privacy-link-wrapper">
            <a [routerLink]="['/terms-condition']" class="link-footer inline first">Terms &amp; Conditions</a>
            <a [routerLink]="['/privacy']" class="link-footer inline">Privacy Policy</a>
            <!-- <a href="http://www.niklasbubori.com" class="link-footer inline">Designed by NB</a> -->
          </div>
        </div>
      </div>
    </div>
    <div class="bg-section bg-background"></div>
  </footer>